var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEstonia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 14,
    viewBox: "85.5 0 27 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.046417
  }, /*#__PURE__*/React.createElement("rect", {
    x: 85.5,
    width: 27,
    height: 14,
    fill: "#111"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.5,
    width: 27,
    height: 4.6667,
    fill: "#368fd8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.5,
    y: 9.3333,
    width: 27,
    height: 4.6667,
    fill: "#fff"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstonia);
export default __webpack_public_path__ + "static/media/estonia.ee3682d1eee316c39588509614733a93.svg";
export { ForwardRef as ReactComponent };